<template>
	<div>
		<header class="page-title">
			<h2>Meta & SEO <span class="page-subtitle">{{ pageTitle }} </span>
			</h2>
			<div class="ml-auto">
				<button @click="saveSeo" class="btn btn-md btn-success" v-if="updateRole">
					<i class="fas fa-save"></i> Save Changes
				</button>
			</div>
		</header>
		<div class="flex box">
			<div :class="boxClass">
				<slot name="custom-text"></slot>
				<div class="card">
					<header class="card-header language-list">
						<h3 class="card-title">Meta Tags</h3>
						<lang-selector></lang-selector>
					</header>
					<div class="card-body">
						<section>
							<h4 class="card-subtitle">Currently Used Meta Tags</h4>
							<div class="table-responsive">
								<table>
									<thead>
										<tr>
											<th>Key</th>
											<th>Value</th>
											<th>Code Preview</th>
											<th class="actions" v-if="updateRole">Actions</th>
										</tr>
									</thead>
									<tbody v-if="currentMetas !== false">
										<tr v-for="(currentMeta, currentMetaIndex) in currentMetas" v-if="currentMeta.values[clickedLang].content !== ''">
											<td>{{ currentMeta.key }}</td>
											<td>
												<span>{{ currentMeta.values[clickedLang].content }}</span>
											</td>
											<td>
												<code>{{ currentMeta.previews[clickedLang] }}</code>
											</td>
											<td v-if="updateRole">
												<button
														@click="showMetaTagModal(currentMetaIndex)"
														class="btn btn-icon btn-primary"
														title="Edit"
												>
													<i class="fas fa-fw fa-pencil-alt"></i>
												</button>
												<button
														@click="deleteMetaTag(currentMetaIndex)"
														class="btn btn-icon btn-danger"
														title="Delete"
												>
													<i class="fas fa-fw fa-trash"></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</section>
						<section v-if="updateRole">
							<h4 class="card-subtitle">Add New Meta Tag</h4>
							<div class="flex box end">
								<div class="form-group four mb-0">
									<label for="meta-name">Meta Name</label>
									<select id="meta-name" required v-model="selectedMetaName">
										<option disabled selected value="Select Meta Tag">Select Meta Tag</option>
										<optgroup :label="metaGroupIndex" v-for="( metaGroupName, metaGroupIndex ) in metas">
											<option v-for="( metaName, metaIndex ) in metas[metaGroupIndex]">{{ metaGroupIndex + '.' + metaIndex }}</option>
										</optgroup>
									</select>
								</div>
								<div class="form-group four mb-0">
									<label class="control-label" for="meta-value">Meta Value</label>
									<vue-select
											:options="metaValues"
											id="meta-value"
											name="meta-value"
											required
											taggable
											v-model="selectedMetaValue"
									>
									</vue-select>
								</div>
								<a @click.prevent="addNewMetaTag(selectedMetaValue.value,selectedMetaValue.label,selectedMetaName)" class="btn btn-primary four" href="#">
									<i class="fas fa-plus"></i> Add
								</a>
							</div>
						</section>
					</div>

					<!-- MODAL -->
					<modal @close="closeMetaTagModal" v-if="currentlyEditedMeta.values[clickedLang]" v-show="isMetaTagModalVisible">
						<template slot="header">
							<h4 class="modal-title">Edit Meta Tag</h4>
						</template>
						<template slot="body" v-if="currentlyEditedMeta">
							<div class="form-group">
								<label>Edited key: {{ currentlyEditedMeta.key }}</label>
								<vue-select
										:options="metaValues"
										@search:focus="editTypedTextMetaValue"
										ref="editMetaInVueSelect"
										required
										taggable
										v-model="currentlyEditedMeta.values[clickedLang].content"
								>
								</vue-select>
							</div>
						</template>
						<template slot="footer">
							<a @click="closeMetaTagModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
							<a @click="saveMetaEditChanges" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
						</template>
					</modal>
					<!-- / MODAL END -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {eventBus} from '../../app';
	import VueSelect from '../../../../node_modules/vue-select';
	import modal from '../Modal/DefaultModal.vue';
	import draggable from 'vuedraggable';


	export default {
		components: {
			"vue-select": VueSelect,
			"modal": modal,
			draggable
		},
		props: {
			dataIsDraft: {
				type: Boolean
			},
			dataUpdateRole: {
				type: Boolean
			},
			dataIsArticle: {
				type: Boolean
			}
		},
		data() {
			return {
				articleId: 0, //api,ok
				userRoles: this.$currentUserRoles,
				pageId: 0, //api,ok
				pageTitle: '', //api,ok
				isDraft: this.dataIsDraft ? this.dataIsDraft : false,
				updateRole: this.dataUpdateRole ? this.dataUpdateRole : true,
				isArticle: this.dataIsArticle ? this.dataIsArticle : false,

				availableLanguages: this.$availableLanguages,
				clickedLang: this.$defaultLanguage.locale ? this.$defaultLanguage.locale : 'en',
				currentMetas: false, //api,ok
				metas: {}, //api,ok
				tags: {}, //api.ok
				metasForSave: {},

				submodulesLoaded: 0,
				submodulesToLoad: 2,

				parentObject: {},

				boxClass: 'twelve-lg',

				selectedMetaName: "",
				selectedMetaValue: "",
				isMetaTagModalVisible: false,
				currentlyEditedMeta: {
					id: 0,
					key: '',
					previews: {},
					targetId: 0,
					values: {}
				}
			}
		},
		created() {
			let vm = this;
			vm.initCurrentlyEditedMeta();

			eventBus.$on('setActiveStatus', (clickedLang) => {
				vm.clickedLang = clickedLang;
			});

			vm.readSeoFromApi();
		},
		computed: {
			metaValues: function () {
				let arrayHelper = [];

				arrayHelper.push({
					text: "Select or set value",
					value: "Select or set value",
					label: "Select or set value"
				});
				for (let tag in this.tags) {
					if (this.tags.hasOwnProperty(tag)) {
						arrayHelper.push({
							value: tag,
							label: this.tags[tag]
						});
					}
				}

				return arrayHelper;
			},

			selectedMetaCodePreview: function () {
				let selectedPattern = '';
				let newContentToPatternPredefined = this.selectedMetaValue.value ? this.selectedMetaValue.value : '';
				let newContentToPatternTyped = this.selectedMetaValue.label ? this._escapeHtmlTagsFromMetaValue(this.selectedMetaValue.label) : '';

				for (let metaCategory in this.metas) {
					for (let metaNameInCategory in this.metas[metaCategory]) {

						if (metaNameInCategory == this.selectedMetaName.substring(this.selectedMetaName.indexOf('.') + 1)) {
							selectedPattern = this.metas[metaCategory][metaNameInCategory].pattern;
							break;
						}
					}
				}
				if (newContentToPatternPredefined != '') {
					return selectedPattern.replace('#content#', newContentToPatternPredefined);
				} else {
					return selectedPattern.replace('#content#', newContentToPatternTyped);
				}
			}
		},
		methods: {
			deleteMetaTag: function (metaIndex) {
				this.currentMetas[metaIndex].values[this.clickedLang].content = '';
				this.currentMetas[metaIndex].previews[this.clickedLang] = '';
				return;
			},

			addNewMetaTag: function (metaId, metaValue, metaName) {
				let vm = this;
				let values = {};
				let previews = {};

				if (metaName === '' || metaName === null || metaValue === '' || metaValue === null) {
					this.$toastr.error('Please select one Meta name or value', 'Error');
					return;
				}

				for (let lang in vm.$availableLanguages) {
					if (vm.$availableLanguages[lang].locale === vm.clickedLang) {
						previews[vm.$availableLanguages[lang].locale] = vm.selectedMetaCodePreview;

						values[vm.$availableLanguages[lang].locale] = {
							content: this._escapeHtmlTagsFromMetaValue(metaValue)
						}
					} else {
						previews[vm.$availableLanguages[lang].locale] = "";
						values[vm.$availableLanguages[lang].locale] = {content: ""};
					}
				}

				vm.currentMetas.push({
					id: metaId,
					group: '',
					key: metaName,
					previews: previews,
					targetId: vm.articleId,
					values: values
				});
				return vm.currentMetas;
			},

			closeMetaTagModal: function () {
				this.isMetaTagModalVisible = false;
			},

			showMetaTagModal: function (metaId) {
				let vm = this;
				let values = {};
				let previews = {};

				for (let lang in vm.$availableLanguages) {
					if (vm.$availableLanguages[lang].locale === vm.clickedLang) {
						previews[vm.$availableLanguages[lang].locale] = this._escapeHtmlTagsFromMetaValue(vm.currentMetas[metaId].previews[vm.clickedLang]);

						values[vm.$availableLanguages[lang].locale] = {
							content: {
								label: this._escapeHtmlTagsFromMetaValue(vm.currentMetas[metaId].values[vm.clickedLang].content),
								value: this._escapeHtmlTagsFromMetaValue(vm.currentMetas[metaId].values[vm.clickedLang].content)
							}
						}
					} else {
						previews[vm.$availableLanguages[lang].locale] = "";
						values[vm.$availableLanguages[lang].locale] = {content: ""};

					}
				}

				vm.isMetaTagModalVisible = true;
				vm.currentlyEditedMeta = {
					id: metaId,
					key: vm.currentMetas[metaId].key,
					previews: previews,
					targetId: vm.currentMetas[metaId].targetId,
					values: values
				};
			},

			editTypedTextMetaValue: function () {
				let vm = this;
				let foundMetaValueLikeThis = false;

				for (let optionLabel in vm.$refs.editMetaInVueSelect.mutableOptions) {
					if (vm.$refs.editMetaInVueSelect.mutableOptions[optionLabel].label == vm.$refs.editMetaInVueSelect.mutableValue.label) {
						foundMetaValueLikeThis = true;
						break;
					}
				}

				// Ha nem talált egyezést a meglévő metaValue-kkal, akkor ez egy begépelt szöveg
				if (foundMetaValueLikeThis === false) {
					return vm.$refs.editMetaInVueSelect.search = vm.$refs.editMetaInVueSelect.mutableValue.label;
				}
			},

			saveMetaEditChanges: function () {
				let vm = this;
				let contentToInsertIntoPreview = '';

				if (vm.currentlyEditedMeta.values[vm.clickedLang].content.value) {
					contentToInsertIntoPreview = vm.currentlyEditedMeta.values[vm.clickedLang].content.value;
				} else if (vm.currentlyEditedMeta.values[vm.clickedLang].content.label) {
					contentToInsertIntoPreview = vm.currentlyEditedMeta.values[vm.clickedLang].content.label;
				} else {
					contentToInsertIntoPreview = vm.currentlyEditedMeta.values[vm.clickedLang].content;
				}

				vm.currentMetas[vm.currentlyEditedMeta.id].previews[vm.clickedLang] = this._setCodePreview(vm.currentlyEditedMeta.key, vm.currentMetas[vm.currentlyEditedMeta.id].values[vm.clickedLang].content, contentToInsertIntoPreview);
				vm.currentMetas[vm.currentlyEditedMeta.id].values[vm.clickedLang].content = this._escapeHtmlTagsFromMetaValue(contentToInsertIntoPreview);

				this.closeMetaTagModal();
			},

			saveSeo: function () {
				if (this.parentObject.type === 'article') {
					let vm = this;

					/* Listening in ContentPage */
					eventBus.$emit('updateCurrentMetas', {currentMetas: vm.currentMetas});

					axios.post('/api/' + vm.$selectedSite.slug + '/articles/' + vm.articleId + '/saveSeo', {
						currentMetas: vm.currentMetas,
						pageId: vm.pageId
					})
						.then(response => {

							vm.$toastr.success('Seo saved successfully', 'Success');

						})
						.catch(e => {
							vm.errors.record(e.response.data);
							this.$toastr.error('Seo save failed.', 'Error');
						});
				} else {
					this.saveSeoByClassAndId();
				}
			},

			_escapeSpecialCharsFromMetaValue: function (patternToEscape) {
				const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·_,:;';
				const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz-----';
				const p = new RegExp(a.split('').join('|'), 'g');

				let escapedPattern = patternToEscape.toString().toLowerCase()
					.replace(/\s+/g, '-') // Replace spaces with -
					.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
					.replace(/&/g, '-and-') // Replace & with ‘and’
					.replace(/[^\w\-\/]+/g, '') // Remove all non-word characters
					.replace(/\-\-+/g, '-') // Replace multiple - with single -
					.replace(/^-+/, '') // Trim - from start of text
					.replace(/-+$/, ''); // Trim - from end of text

				return escapedPattern;
			},

			_escapeHtmlTagsFromMetaValue: function (stringToEscape) {
				return stringToEscape.replace(/(<([^>]+)>)/ig, "");
			},

			_setCodePreview: function (metaName, textToChange, textToInsertIntoPreview) {
				let previewPattern = '';
				let oldTagKeyToChange = '';
				textToInsertIntoPreview = this._escapeHtmlTagsFromMetaValue(textToInsertIntoPreview);

				// Find tag id by tag name
				for (let tagName in this.tags) {
					if (this.tags[tagName] == textToChange) {
						oldTagKeyToChange = tagName;
						break;
					}
				}

				//magic
				let metaGroup = metaName.split('.')[0];
				metaName = metaName.slice(metaName.indexOf('.') + 1);

				// Get preview by meta name
				for (let metaCategory in this.metas) {
					if (metaCategory == metaGroup) {
						for (let metaNameInCategory in this.metas[metaCategory]) {
							if (metaNameInCategory == metaName) {
								previewPattern = this.metas[metaCategory][metaNameInCategory].pattern;
								break;
							}
						}
					}
				}
				return previewPattern.replace(/\#(.+)\#/g, textToInsertIntoPreview);
			},

			//only api below
			readSeoFromApi: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/getseo',
					{
						url: window.location.pathname
					}
				).then(function (response) {
					if (typeof response.data.error !== 'undefined') {
						this.$toastr.error(data.error, 'Error');
					} else {
						vm.initData(response.data);
						vm.$toastr.success('Seo loaded successfully', 'Success');
					}
				}).catch(function (e) {
					vm.errors.record(e.response.data);
					vm.$toastr.error('Seo loading failed.', 'Error');
				});
			},
			initData: function (data) {
				if (typeof data.parent !== 'undefined' && typeof data.parent.obj !== 'undefined') {
					this.parentObject = data.parent ? data.parent : {};
					this.articleId = data.parent.id;
					this.pageId = data.parent.page;
					this.pageTitle = this.parentObject.obj.title;
				}
				if (typeof data.seoBox !== 'undefined') {
					this.currentMetas = data.seoBox.currentMetas ? data.seoBox.currentMetas : {};
					this.tags = data.seoBox.tags ? data.seoBox.tags : {};
					this.metas = data.seoBox.metas ? data.seoBox.metas : {};
				}
				eventBus.$emit('module_metaseo_data', data);
				this.getClass();
				this.initCurrentlyEditedMeta();

			},
			initCurrentlyEditedMeta: function () {
				let vm = this;
				for (let lang in vm.$availableLanguages) {
					vm.currentlyEditedMeta.values[vm.$availableLanguages[lang].locale] = {
						content: ''
					};
					vm.currentlyEditedMeta.previews[vm.$availableLanguages[lang].locale] = "";
				}
			},
			getClass: function () {
				this.boxClass = 'twelve-lg';
			},
			saveSeoByClassAndId: function () {
				let vm = this;

				axios.post('/api/' + this.$selectedSite.slug + '/saveseo/' + this.parentObject.type + '/' + this.parentObject.id, {
					id: vm.parentObject.id,
					type: vm.parentObject.type,
					page: vm.pageId,
					currentMetas: vm.currentMetas,
				})
					.then(response => {

						vm.$toastr.success('Seo saved successfully', 'Success');

					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Seo save failed.', 'Error');
					});
			}
		}
	}
</script>

<style scoped>

</style>
